import i18next from 'i18next';
import { ReactComponent as ShippedIcon } from 'assets/icons/shipped.svg';
import { ReactComponent as PendingIcon } from 'assets/icons/pending.svg';

/**
 * Status enum for Claim Reports / Reportables.
 *
 * Lives in @shared/lib because it is consumed by both the
 * claim-report entity (column filter options) and the reportable
 * entity (baseFilter on the list endpoint). FSD forbids
 * entity-to-entity imports, so the cross-cutting enum belongs in
 * shared.
 */
export const CLAIM_REPORTS_STATUSES = {
  reported: 'reported',
  reportable: 'reportable',
};

export const CLAIM_REPORTS_STATUSES_OPTIONS = [
  {
    label: i18next.t('tables:reported'),
    value: CLAIM_REPORTS_STATUSES.reported,
    icon: ShippedIcon,
    enabledForNonSponsors: false,
  },
  {
    label: i18next.t('tables:reportable'),
    value: CLAIM_REPORTS_STATUSES.reportable,
    icon: PendingIcon,
    enabledForNonSponsors: false,
  },
];
